export { SnippetConfig, type SnippetTargetType } from './snippets'
export { routes } from './routes'
export { baseUrls } from './baseUrls'

export const API_KEY_HEADER_KEY = 'apiKey'
export const API_REFERENCE_PREFIX = 'api-reference'
